import { Box, Tr, Checkbox, Flex, Th } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export function LoanColumns({
    columns,
    orderBy,
    setOrderBy,
    onRowSelect,
    selectAllCheck,
}: {
    columns: any;
    orderBy: any;
    setOrderBy: (orderBy: any) => void;
    onRowSelect: () => void;
    selectAllCheck: any;
}) {
    return (
        <Tr>
            {columns
                .filter((col: any) => col.show)
                .map((col: any) => (
                    <React.Fragment key={col.id}>
                        {col.label === "Select" ? (
                            <Th key={col.id} width="36px">
                                <Flex alignItems="center">
                                    <Checkbox
                                        colorScheme="teal"
                                        isChecked={selectAllCheck}
                                        onChange={onRowSelect}
                                    />
                                </Flex>
                            </Th>
                        ) : (
                            <Th
                                cursor="pointer"
                                key={col.id}
                                onClick={() =>
                                    setOrderBy({
                                        column: col.id,
                                        direction: {
                                            ascending:
                                                !orderBy.direction.ascending,
                                        },
                                    })
                                }
                            >
                                {col.label}
                                {orderBy.column === col.id && (
                                    <Box ml="8px" display="inline-block">
                                        <FontAwesomeIcon
                                            fontSize="12px"
                                            icon={[
                                                "far",
                                                orderBy.direction.ascending
                                                    ? "chevron-up"
                                                    : "chevron-down",
                                            ]}
                                        />
                                    </Box>
                                )}
                            </Th>
                        )}
                    </React.Fragment>
                ))}
        </Tr>
    );
}
